var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { genBaseOptions } from "./index";
const MAX_RETRY_TIME = 0;
const EventStreamContentType = "text/event-stream";
export const sseRequester = function (requestInfo) {
    var _a;
    const { url, config = {} } = requestInfo;
    const controller = new AbortController();
    const { body } = url;
    const { onMessage, onClose, onError } = body, rest = __rest(body, ["onMessage", "onClose", "onError"]);
    body.onMessage = undefined;
    body.onClose = undefined;
    body.onError = undefined;
    const options = genBaseOptions(requestInfo);
    function close() {
        controller.abort();
    }
    function formatMessage(m) {
        // 响应处理
        return onMessage === null || onMessage === void 0 ? void 0 : onMessage(m.data, m.event);
    }
    let leftRetries = Math.max(((_a = body === null || body === void 0 ? void 0 : body.retryTimes) !== null && _a !== void 0 ? _a : MAX_RETRY_TIME) - 1, 0);
    fetchEventSource(url.path, Object.assign(Object.assign({}, options), { 
        // 请求处理
        body: JSON.stringify(rest), signal: controller.signal, openWhenHidden: true, onmessage: formatMessage, onclose: onClose, onopen: (response) => __awaiter(this, void 0, void 0, function* () {
            if (leftRetries < 0) {
                close();
            }
            const contentType = response.headers.get("content-type");
            if (contentType !== EventStreamContentType) {
                throw new Error(`Expected content-type to be ${EventStreamContentType}, Actual: ${contentType}`);
            }
        }), onerror: (e) => {
            leftRetries--;
            onError === null || onError === void 0 ? void 0 : onError(e);
        } })).catch((e) => {
        // catch err
        console.error(e);
    });
    return Promise.resolve({
        data: {
            __close: close,
        },
        // FIXME SSE目前没有接入异常处理机制。因此视作返回200，代表请求成功。
        status: 200,
    });
};
